export enum SIZE_PICKER_TYPE {
    CHIPS = 'chips',
    DROPDOWN = 'dropdown',
    CHIPS_THUMBNAIL = 'chips_thumbnail'
}
